import { defineMessages } from 'react-intl'

export const lang = defineMessages({
  supportAgree: {
    id: 'donater.form.support_agree',
    defaultMessage: 'I want to support {name} and cover the service fee.',
  },
  donateButton: {
    id: 'donater.form.donate_button',
    defaultMessage: 'Go to donation',
  },
})
